import { Component } from '@angular/core';


@Component({
	selector: 'finance-cost-tab-1-part',
	standalone: true,
	templateUrl: './finance-cost-tab-1.part.html',
	styleUrls: [`./finance-cost-tab-1.part.scss`],
})
export class FinanceCostTab1Part {
}
